/* eslint-disable import/no-cycle */
import { call, put, takeEvery } from 'redux-saga/effects';
import { operations } from '../../api/api';
import {
  GET_OPERATIONS,
  GET_OPERATIONS_SUCCESS,
  GET_OPERATIONS_FAILURE,
  GET_OPERATION,
  GET_OPERATION_SUCCESS,
  GET_OPERATION_FAILURE
} from './operationsActions';

import logger from '../../utils/logger';

/**
 * Récupération de plusieurs operations
 * @param  {Object} action action object
 */
export function* getOperations(action) {
  try {
    const response = yield call(operations.getOperations, action.payload);
    if (response.data.success === true) {
      yield put({ type: GET_OPERATIONS_SUCCESS, payload: response.data });
    } else {
      yield put({ type: GET_OPERATIONS_FAILURE });
    }
  } catch (error) {
    logger(error);
    yield put({ type: GET_OPERATIONS_FAILURE });
  }
}

/**
 * Récupération du détail d'une opération
 * @param  {Object} action action object
 */
export function* getOperation(action) {
  try {
    const response = yield call(operations.getOperation, action.payload);
    if (response.data.success === true) {
      yield put({ type: GET_OPERATION_SUCCESS, payload: response.data });
    } else {
      yield put({ type: GET_OPERATION_FAILURE });
    }
  } catch (error) {
    logger(error);
    yield put({ type: GET_OPERATION_FAILURE });
  }
}

const signinSaga = [
  takeEvery(GET_OPERATIONS, getOperations),
  takeEvery(GET_OPERATION, getOperation)
];

export default signinSaga;
